const scrollShop = ( $ ) => {
	
};

export default scrollShop;